import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { User } from 'src/app/front-user/shared/models/user.model';
import { BaseRequest } from 'src/app/shared/models/base-request.model';
import { CrewChangeAdminDTO } from 'src/app/shared/models/crewChange.model';
import { CCAgentDecision, FormMode, Languages } from 'src/app/shared/models/enums.model';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { BaseRequestService } from 'src/app/front-user/shipyard-service/services/base-request.service';
import { AlertService } from 'src/app/shared/components/alert/alert.service';
import { CrewChangeService } from 'src/app/shared/services/crewChange.service';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { first } from 'rxjs/operators';
import { CrewchangeApprovalDecisionComponent } from 'src/app/admin/e-services/CrewChange/crewchange-approval-decision/crewchange-approval-decision.component';

@Component({
  selector: 'app-crew-change-agent-approval',
  templateUrl: './crew-change-agent-approval.component.html',
  styleUrls: ['./crew-change-agent-approval.component.css']
})
export class CrewChangeAgentApprovalComponent implements OnInit {

  submitted = false;
  loading = false;
  baseRequestId: string = '';
  requestStatus: number;
  baseRequestDTO: BaseRequest//= new BaseRequest();
  agentDecision = CCAgentDecision;
  decisionKeys = Object.keys(this.agentDecision);
  displayedLang: string;
  decisionValue: number;
  crewChangeAgentApprovalForm: FormGroup;
  currentUser: User = new User();
  adminDecisionObject: CrewChangeAdminDTO = new CrewChangeAdminDTO();
  showRequest = false;
  public FormMode: any = FormMode;
  public formMode: any = FormMode.Add;
  isLoaded: boolean = false;
  isErrorMessage: boolean = false;
  @ViewChild('CrewChangeApprovalDecision',{static: false}) CrewChangeApprovalDecision: CrewchangeApprovalDecisionComponent;
  responseObj: ResponseObject = new ResponseObject();
  lockTaskErrorMessage: boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    private baseRequestService: BaseRequestService,
    private globalSrv: GlobalServices,
    private alertService: AlertService,
    private crewChangeService: CrewChangeService,
  ) {
    this.decisionKeys = this.decisionKeys.slice(this.decisionKeys.length / 2);
    this.displayedLang = this.globalSrv.getLanguage() == Languages.Arabic ? 'NameAR' : 'NameEN';
    if (history.state.data && history.state.data.requestId) {
      this.baseRequestId = history.state.data.requestId;
      this.getBaseRequest();
    } else {
      window.history.back();
    }
    this.currentUser = this.globalSrv.user;
   }

  ngOnInit() {
    this.buildForm();
  }
  buildForm() {
    this.crewChangeAgentApprovalForm = this.formBuilder.group({
      AgentDecision: ['', [Validators.required]],
      Notes: [''],
    });
  }
  get f() {
    return this.crewChangeAgentApprovalForm.controls;
  }

  getBaseRequest() {
    this.baseRequestService.getBaseRequest(this.baseRequestId).subscribe(
      d => {
        this.baseRequestDTO = d.Data;
        this.requestStatus = this.baseRequestDTO.StatusId;
        this.isLoaded = true;
        if (history.state.data && history.state.data.isCompleted) {
          this.getCrewChangeRequest();
          this.formMode = FormMode.Readonly;
          this.crewChangeAgentApprovalForm.disable();
        }
      }
    )
  }

  getCrewChangeRequest() {
    this.crewChangeService.getById(this.baseRequestId).pipe(first()).subscribe(
      (resObj: ResponseObject) => {
        this.responseObj = resObj;
        if (this.responseObj.Success) {
            this.buildForm();
            this.crewChangeAgentApprovalForm.patchValue({
              AgentDecision: this.responseObj.Data["AgentDecision"],
              Notes: this.responseObj.Data['AgentNotes'],
            });
        }
      }

    );
  }

  onSubmit(b) {
    this.submitted = true;
    // stop here if form is invalid
    if (this.crewChangeAgentApprovalForm.invalid) {
      return;
    }
    this.alertService.clear();
    this.globalSrv.isLoaderEnabled = true;
    this.loading = true;
    this.adminDecisionObject.AgentDecision = this.crewChangeAgentApprovalForm.controls['AgentDecision'].value;
    this.adminDecisionObject.AgentNotes = this.crewChangeAgentApprovalForm.controls['Notes'].value;
    this.adminDecisionObject.Id = this.baseRequestId;

  this.crewChangeService.AddAgentApprovalDecision(this.adminDecisionObject)
    .subscribe(
      (data: ResponseObject) => {
        if (data.Success) {
          this.globalSrv.isLoaderEnabled = false;
          this.crewChangeAgentApprovalForm.reset();
          this.loading = false;
          this.showRequest = true;
          this.isErrorMessage = false;
        }
        else if (data.ErrorMessages.find(e => e == "TaskCompletedByAnotherUser") != null) {
          this.lockTaskErrorMessage = true;
          this.showRequest = true;
          this.globalSrv.isLoaderEnabled = false;
        }
        else {
          this.globalSrv.isLoaderEnabled = false;
          this.showRequest = true;
          this.isErrorMessage = true;
          this.loading = false;
        }

      });
}



}
